export default __webpack_public_path__ + "static/media/number.12cbbd6a.svg";